// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1EfJM","label":"SetPasswdForm_label__2D-p8"};